import { Product } from '../../../../common/js/static/Product';
export const DefaultQuote = {
  product: Product.products.CASTerm.code,
  productType: Product.productTypes.Term.code,
  faceAmount: 1e5,
  term: 20,
  smoker: false,
  dateOfBirth: new Date('January 1, 1983'),
  premium: 0,
  healthClass: 'ULTRA',
  contractState: 'MA',
  waiverOfPremium: false,
  gender: 'male',
  waiverOfPremiumAmount: 0,
  policies: [{}],
  paymentFrequency: 'Monthly',
};
